import React from 'react'
import styles from './BackGround.module.scss';

// eslint-disable-next-line react/prop-types
function BackGroundLayout({ backGroundText = '', overlapText = '' }) {
  return (
    <div className={styles.mixedText}>
      <h1 className={styles.sectionContent}>{backGroundText}</h1>
      <p className={styles.knmMe}>{overlapText}</p>
      <span className={styles.separator}></span>
    </div>
  )
}

export default BackGroundLayout;